module.exports = __webpack_public_path__ + "efd1ee4b4eba583b8370ff33e91cf653.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/6.jpg
 ** module id = 216
 ** module chunks = 0
 **/